<template>
	<div id="app" :class="{
    // 控制tabbar显示时底部padding值
    'padding-footer-tabbar': $route.meta.showTabbar,
  }">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath"></router-view>

    <!-- 底部tabbar -->
		<footer-tabbar v-if="$route.meta.showTabbar"></footer-tabbar>

    <div class="top-float" v-show="$route.meta.toTop && scrollTop >= 300" @click.stop="toTop">
      <img src="./assets/top-icon.png">
    </div>
	</div>
</template>

<script>
	import FooterTabbar from './components/footer-tabbar.vue'

  !(function (n, e) {
    function setViewHeight() {
      var windowVH = e.innerHeight / 100
      n.documentElement.style.setProperty('--vh', windowVH + 'px')
    }
    var i = 'orientationchange' in window ? 'orientationchange' : 'resize'
    n.addEventListener('DOMContentLoaded', setViewHeight)
    e.addEventListener(i, setViewHeight)
  })(document, window)

	export default {
		name: 'app',
		components: {
			FooterTabbar
		},
    data() {
      return {
        scrollTop: 0,
      }
    },
    mounted() {
      const onscroll = () => {
        this.scrollTop = this.getScrollTop();
      }
      window.addEventListener('scroll',onscroll);
      // 兼容谷歌浏览器 地址栏高度 影响定位遮挡问题
      try {
        document.documentElement.style.setProperty('--viewport-height', `${visualViewport.height}px`);
        visualViewport.addEventListener('resize', () => {
          document.documentElement.style.setProperty('--viewport-height', `${visualViewport.height}px`);
        });

        // function setViewHeight() {
        //   var windowVH = window.innerHeight / 100;
        //   document.documentElement.style.setProperty('--vh', windowVH + 'px');
        //   Toast(windowVH);
        // }
        // let i = 'orientationchange' in window ? 'orientationchange' : 'resize';
        // document.addEventListener('DOMContentLoaded', setViewHeight);
        // window.addEventListener(i, setViewHeight);


        // let windowsVH = window.innerHeight / 100;
        // document.documentElement.style.setProperty('--vh', windowsVH + 'px');
        // window.addEventListener('resize', function() {
        //   document.documentElement.style.setProperty('--vh', windowsVH + 'px');
        // });
      } catch (e) {
      }




    },
    methods: {
      toTop() {
        document.documentElement.scrollTop = document.body.scrollTop = 0;
      },
      /**
       * 获取滚动条位置
       */
      getScrollTop() {
        var scrollPos;
        if (window.pageYOffset) {
          scrollPos = window.pageYOffset;
        } else if (document.compatMode && document.compatMode !== 'BackCompat') {
          scrollPos = document.documentElement.scrollTop;
        } else if (document.body) {
          scrollPos = document.body.scrollTop;
        }
        return scrollPos;
      },
      /**
       * 获取滚动条位置
       */
      setScrollTop() {
        var scrollPos;
        if (window.pageYOffset) {
          scrollPos = window.pageYOffset;
        } else if (document.compatMode && document.compatMode !== 'BackCompat') {
          scrollPos = document.documentElement.scrollTop;
        } else if (document.body) {
          scrollPos = document.body.scrollTop;
        }
        return scrollPos;
      }
    }
  }
</script>

<style>
  :root {
    --viewport-height: 100vh;
    --vh: 1vh;
  }

	* {
		margin: 0;
		padding: 0;
    white-space:normal;
    word-break:break-all;
	}

	body {
		/* 底部 iPhone X 兼容 */
		padding-bottom: constant(safe-area-inset-bottom);
		padding-bottom: env(safe-area-inset-bottom);
	}

	/* 控制tabbar显示时底部padding值 */
	.padding-footer-tabbar {
		padding-bottom: 50px;
	}

	button {
		border: none;
		background-color: initial;
		border-radius: initial;
	}

	input {
		border: none;
		background-color: initial;
	}

	textarea {
		border: none;
		resize: none;
		background-color: initial;
	}

	::-webkit-scrollbar {
		display: none
	}

	* {
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

  /* ios 微信输入问题 */
  [contenteditable="true"], input, textarea {
    -webkit-user-select: auto!important;
    -khtml-user-select: auto!important;
    -moz-user-select: auto!important;
    -ms-user-select: auto!important;
    -o-user-select: auto!important;
    user-select: auto!important;
  }

  /* 去掉搜索图标 */
  input[type="search"]{-webkit-appearance:none;}
  input::-webkit-search-cancel-button {display: none;}


  /* 回到顶部 */
  .top-float {
    position: fixed;
    bottom: 20%;
    right: 18px;
    z-index: 999;
    display: flex;
    align-items: center;
  }

  .top-float>img {
    width: 40px;
  }
  /* 弹窗top高度，防止第三方浏览器播放视频时遮挡弹窗 */
  .van-dialog {
    top: 344px !important;
  }
</style>
